import { Box, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextFieldComponent from "../../../../Components/TextFieldComponent";
import MobileNumberField from "../../../../Components/MobileNumberField";
import { validateFields } from "../../../../Helper/ValidateFields";
import Btn from "../../../../Components/Ui_elements/Btn";
import { useParams } from "react-router-dom";
import {
  CreateContactExternal,
  deleteContactExternal,
  getContactExternalResource,
  updateExternalContact,
} from "../../../../redux/Thunk/externalResourceThunk";
import GenericTable from "../../../../Components/Ui_elements/GenericTable";
import { SortAlphabetically } from "../../../../Helper/SortAlphbetically";
import PopupModal from "../../../../Components/Ui_elements/PopupModal";

const Step5 = ({ registerSubmit }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { new_external_created, contactExternalResource } = useSelector(
    state => state.root.ExternalResource
  );
  const initialState = {
    vFirstName: "",
    vLastName: "",
    vEmail: "",
    vSkype: "",
    vJobTitle: "",
    mobile: {
      countryIso: "US",
      phoneCode: "1",
      number: "",
      nicename: "",
    },
  };
  const newId = id ? id : new_external_created?.iUserId || "";
  const [isEdit, setIsEdit] = useState(false);
  const [openForDelete, setOpenForDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState(initialState);
  const [contactId, setContactId] = useState("");

  const handleChange = e => {
    const { name, value } = e.target;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (name === "mobile") {
      const rawValue = value?.number ?? ""; // fallback to empty string
      const digitsOnly = rawValue.replace(/\D/g, "");

      setFormData(prevData => ({
        ...prevData,
        [name]: {
          ...value,
          number: digitsOnly, // update only the number part, keep rest intact
        },
      }));
    } else {
      setFormData({ ...formData, [name]: value });
      //   setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      if (name === "vEmail") {
        setErrors(prevErrors => ({
          ...prevErrors,
          [name]: value && !emailRegex.test(value) ? "Please enter a valid email address" : "",
        }));
      } else {
        setErrors(prevErrors => ({ ...prevErrors, [name]: "" }));
      }
    }
    //  if (name === "vEmail" && !emailRegex.test(value)) {
    //   setErrors((prevData) => ({
    //     ...prevData,
    //     [name]: "Please enter a valid email address",
    //   }));
    // }
  };

  const formFields = [
    { name: "vFirstName", label: "First Name" },
    { name: "vLastName", label: "Last Name" },
    { name: "vEmail", label: "Email" },
    { name: "vJobTitle", label: "Job Title" },
    { name: "vSkype", label: "Slack/Teams" },
  ];

  const handleSubmit = e => {
    const newErrors = validateFields(formData, formFields);

    // Custom validation for mobile number
    if (!formData.mobile.number) {
      newErrors.mobile = "Mobile number is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Formatting the payload
    const payload = {
      ...(isEdit && { iUserId: newId, iContactId: contactId }),
      vFirstName: formData.vFirstName,
      vLastName: formData.vLastName,
      vEmail: formData.vEmail,
      vSkype: formData.vSkype,
      vJobTitle: formData.vJobTitle,
      vPhone: JSON.stringify({
        countryTitle: formData.mobile.nicename, // Assuming nicename holds country title
        countryFlagClass: `iti-flag ${formData.mobile.countryIso.toUpperCase()}`, // Creating flag class
        mobileNumber: formData.mobile.number,
      }),
    };
    if (isEdit === true) {
      dispatch(updateExternalContact({ iUserId: newId, payload })).then(() => {
        dispatch(getContactExternalResource({ user_id: newId }));
        setFormData(initialState);
        setErrors({});
      });
    } else {
      dispatch(CreateContactExternal({ iUserId: newId, payload })).then(() => {
        dispatch(getContactExternalResource({ user_id: newId }));
        setFormData(initialState);
        setErrors({});
      });
    }

    return true;
  };

  const columns = [
    { name: "rowNumber", label: "No.", options: { sort: true } },
    { name: "iContactId", label: "ID", options: { display: false } },
    {
      name: "vFirstName",
      label: "Name",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const lname = tableMeta.rowData[3] || "";
          return (
            <div>
              <p>
                {value} {lname}
              </p>
            </div>
          );
        },
      },
    },
    { name: "vLastName", label: "LastName", options: { display: false } },
    { name: "vEmail", label: "Email" },
    { name: "vSkype", label: "Slack/Teams" },
  ];

  const sortedData = SortAlphabetically(contactExternalResource || [], "vFirstName");
  const data = sortedData?.map((item, index) => ({
    rowNumber: index + 1, // Explicitly add sequential numbers
    iContactId: item.iContactId,
    vFirstName: item.vFirstName,
    vLastName: item.vLastName,
    vEmail: item.vEmail,
    vSkype: item.vSkype,
  }));

  const handleEdit = rowData => {
    const selectedData = contactExternalResource?.find(item => item.iContactId === rowData[1]);
    setContactId(rowData[1]);

    if (selectedData) {
      let mobile = { countryTitle: "", countryFlagClass: "", mobileNumber: "" };

      try {
        mobile = selectedData.vPhone ? JSON.parse(selectedData.vPhone) : mobile;
      } catch (error) {
        console.error("Error parsing vPhone:", error);
      }

      setFormData({
        vFirstName: selectedData.vFirstName || "",
        vLastName: selectedData.vLastName || "",
        vEmail: selectedData.vEmail || "",
        vSkype: selectedData.vSkype || "",
        vJobTitle: selectedData.vJobTitle || "",
        mobile: {
          nicename: mobile.countryTitle || "",
          countryIso: mobile.countryFlagClass.replace("iti-flag ", "") || "",
          phoneCode: "", // Assuming no phone code is provided, needs separate handling
          number: mobile.mobileNumber || "",
        },
      });
      setIsEdit(true);
    } else {
      console.error("Unable to find the selected data for editing.");
    }
  };

  const handleDelete = id => {
    setOpenForDelete(true);
    setDeleteId(id);
  };

  useEffect(() => {
    registerSubmit(handleSubmit);
  }, [formData]);
  return (
    <Box sx={{ background: "#f4f4fb" }}>
      <Paper elevation={1} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} mb={2}>
            <Grid item xs={12} sm={4}>
              <TextFieldComponent
                type="text"
                name="vFirstName"
                label="First Name"
                value={formData.vFirstName}
                onChange={handleChange}
                error={errors.vFirstName || ""}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextFieldComponent
                type="text"
                name="vLastName"
                label="Last Name"
                value={formData.vLastName}
                onChange={handleChange}
                error={errors.vLastName || ""}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextFieldComponent
                type="text"
                name="vEmail"
                label="Email"
                value={formData.vEmail}
                onChange={handleChange}
                error={errors.vEmail || ""}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <MobileNumberField
                id="mobile"
                name="mobile"
                label="Mobile"
                value={formData.mobile}
                onChange={handleChange}
                error={errors?.mobile || ""}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextFieldComponent
                type="text"
                name="vSkype"
                label="Slack/Teams"
                value={formData.vSkype}
                onChange={handleChange}
                error={errors.vSkype || ""}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextFieldComponent
                type="text"
                name="vJobTitle"
                label="Job Title"
                value={formData.vJobTitle}
                onChange={handleChange}
                error={errors.vJobTitle || ""}
                fullWidth
              />
            </Grid>
          </Grid>
        </form>
      </Paper>
      <GenericTable
        columns={columns}
        data={data}
        onEdit={handleEdit}
        onDelete={handleDelete}
        showDelete={true}
        displayColumns={4}
        displayRows={10}
      />
      {openForDelete && (
        <PopupModal
          maxWidth={"sm"}
          fullWidth={true}
          open={openForDelete}
          handleClose={() => setOpenForDelete(false)}
          actions={
            <Grid container columnGap={2} justifyContent={"end"}>
              <Btn
                onClick={() =>
                  dispatch(deleteContactExternal(deleteId)).then(
                    () => dispatch(getContactExternalResource({ user_id: newId })),
                    setOpenForDelete(false)
                  )
                }
              >
                {" "}
                Yes{" "}
              </Btn>
              <Btn onClick={() => setOpenForDelete(false)}>Cancel</Btn>
            </Grid>
          }
          title={<Typography variant="h6">Delete Contact</Typography>}
        >
          <Typography>Are you sure you want to delete?</Typography>
        </PopupModal>
      )}
    </Box>
  );
};

export default Step5;
